<template>
    <div>
        <form @submit.prevent="on_submit" id="submit_form">
            <div class="row">
                <div class="col-12 my-2">
                    <div class="h5" v-text="$t('wallets.label.add_ayande_bank_wallet')"></div>
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="wallet_title" v-text="$t('wallets.label.wallet_title')"></label>
                    <input class="form-control" id="wallet_title" name="wallet_title" v-model="form_data.wallet_title">
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="password"
                           v-text="$t('label.wallet_password')"
                    ></label>
                    <div class="row">
                        <div class="col-1">
                            <button class="form-control"
                                    style="width: fit-content"
                                    type="button"
                                    @click="togglePassword()"
                            >
                                <i class="fas fa-eye"></i>
                            </button>
                        </div>
                        <div class="col-11">
                            <input name="password"
                                   :type="password_type"
                                   id="password"
                                   class="form-control"
                                   v-model="form_data.password"
                            >
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label>
                        <span v-text="$t('label.access_ips_for_webservice')"></span>
                        <span v-text="$t('label.optional_input')" class="mx-1"></span>
                    </label>
                    <button type="button"
                            class="btn btn-primary pl-2 pr-0 py-1 my-0 mx-1"
                            @click="addIp"
                            v-if="form_data.access_ips.length < 10"
                    >
                        <i class="fas fa-plus"></i>
                    </button>
                    <button type="button"
                            class="btn btn-danger pl-2 pr-0 py-1 my-0 mx-1"
                            @click="removeIp"
                            v-if="form_data.access_ips.length > 1"
                    >
                        <i class="fas fa-minus"></i>
                    </button>
                    <div v-for="(access_ip, index) in form_data.access_ips"
                         :key="index"
                         class="mb-2"
                    >
                        <input :id="`access_ips.${index}`"
                               :name="`access_ips.${index}`"
                               class="form-control"
                               dir="ltr"
                               v-model="form_data.access_ips[index]"
                        >
                    </div>
                </div>
                <div class="col-12 mt-4">
                    <button class="btn btn-success" type="submit" v-text="form_meta_data.submit_btn_text"></button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {i18n} from "@/plugins/i18n";
    import $ from "jquery";

    export default {
        props: {
            form_meta_data: {
                type: Object,
                default: () => {
                    return {
                        submit_btn_progress: false,
                        submit_btn_text: i18n.t('btn.submit'),
                    };
                },
            },
            on_submit: {
                type: Function,
                default: () => {
                },
            },
            form_data: {
                type: Object,
                default: () => {
                    return {};
                },
            },
        },
        data() {
            return {
                password_type: 'password',
            };
        },
        methods: {
            togglePassword() {
                this.password_type = this.password_type === 'password' ? 'text' : 'password';
            },
            addIp() {
                if (this.form_data.access_ips.length < 10) {
                    this.form_data.access_ips.push('');
                }
            },
            removeIp() {
                this.form_data.access_ips.pop();
            },
        },
    }
</script>
